import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class TopicService {
  private readonly apiPrefix = '/admin/lesson-topics'

  constructor(
    private api: ApiService
  ) {
  }

  createTopic(data): Observable<any> {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  getTopics(filter = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}${filter}`);
  }

  updateTopic(id, data): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteTopic(id): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  importTopicsWithExcel(data): Observable<any> {
    return this.api.post(`${this.apiPrefix}/upload-excel`, data);
  }
}
